export function rgbToHex(color: number[]): string {
  const [r, g, b] = color;
  return "#" + ((1 << 24) | (r << 16) | (g << 8) | b).toString(16).slice(1);
}
